import { createSlice } from "@reduxjs/toolkit";

const bookingQueueSearchSlice = createSlice({
  name: "bookingQueueSearchSlice",
  initialState: {
    bookingQueueFilter: null,
  },
  reducers: {
    setBookingQueueSearch: (state, action) => {
      state.bookingQueueFilter = action.payload;
    },
  },
});

export const { setBookingQueueSearch } = bookingQueueSearchSlice.actions;
export default bookingQueueSearchSlice.reducer;
